import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  // Common
  'common.save': { de: 'Speichern', en: 'Save' },
  'common.cancel': { de: 'Abbrechen', en: 'Cancel' },
  'common.delete': { de: 'Löschen', en: 'Delete' },
  'common.edit': { de: 'Bearbeiten', en: 'Edit' },
  'common.back': { de: 'Zurück', en: 'Back' },
  'common.search': { de: 'Suche...', en: 'Search...' },
  'common.loading': { de: 'Laden...', en: 'Loading...' },
  'common.error': { de: 'Fehler', en: 'Error' },
  'common.create': { de: 'Erstellen', en: 'Create' },
  'common.close': { de: 'Schließen', en: 'Close' },
  'common.online': { de: 'Online', en: 'Online' },
  'common.offline': { de: 'Offline', en: 'Offline' },
  'common.active': { de: 'Aktiv', en: 'Active' },
  'common.inactive': { de: 'Inaktiv', en: 'Inactive' },
  'common.reset': { de: 'Zurücksetzen', en: 'Reset' },
  'common.execute': { de: 'Ausführen', en: 'Execute' },
  'common.name': { de: 'Name', en: 'Name' },
  'common.status': { de: 'Status', en: 'Status' },
  'common.created': { de: 'Erstellt', en: 'Created' },
  'common.type': { de: 'Typ', en: 'Type' },
  'common.new': { de: 'Neu', en: 'New' },
  'common.copied': { de: 'Kopiert', en: 'Copied' },
  'common.device': { de: 'Gerät', en: 'device' },
  'common.devices': { de: 'Geräte', en: 'devices' },

  // Navigation
  'nav.dashboard': { de: 'Dashboard', en: 'Dashboard' },
  'nav.devices': { de: 'Geräte', en: 'Devices' },
  'nav.groups': { de: 'Gruppen', en: 'Groups' },
  'nav.scripts': { de: 'Skripte', en: 'Scripts' },
  'nav.installStatus': { de: 'Install Status', en: 'Install Status' },
  'nav.users': { de: 'Benutzer', en: 'Users' },
  'nav.tenants': { de: 'Mandanten', en: 'Tenants' },
  'nav.map': { de: 'Karte', en: 'Map' },
  'nav.auditLog': { de: 'Audit Log', en: 'Audit Log' },
  'nav.filemanager': { de: 'Dateimanager', en: 'File Manager' },
  'nav.agentUpdate': { de: 'Agent Update', en: 'Agent Update' },

  // Dashboard
  'dashboard.title': { de: 'Dashboard', en: 'Dashboard' },
  'dashboard.welcome': { de: 'Willkommen', en: 'Welcome' },
  'dashboard.devices': { de: 'Geräte', en: 'Devices' },
  'dashboard.registeredDevices': { de: 'Registrierte Geräte', en: 'Registered devices' },
  'dashboard.activeConnections': { de: 'Aktive Verbindungen', en: 'Active connections' },
  'dashboard.disconnected': { de: 'Getrennt', en: 'Disconnected' },
  'dashboard.tenants': { de: 'Mandanten', en: 'Tenants' },
  'dashboard.allDevices': { de: 'Alle Geräte', en: 'All devices' },
  'dashboard.quickAccess': { de: 'Schnellzugriff', en: 'Quick access' },
  'dashboard.manageDevices': { de: 'Geräte verwalten', en: 'Manage devices' },
  'dashboard.manageTenants': { de: 'Mandanten verwalten', en: 'Manage tenants' },
  'dashboard.agentTitle': { de: 'TSR Remote Agent', en: 'TSR Remote Agent' },
  'dashboard.agentDesc': { de: 'Windows-Agent zur automatischen Erfassung von TeamViewer, RustDesk und AnyDesk IDs.', en: 'Windows agent for automatic detection of TeamViewer, RustDesk, and AnyDesk IDs.' },
  'dashboard.agentDownload': { de: 'Agent Download', en: 'Agent Download' },
  'dashboard.total': { de: 'Total', en: 'Total' },
  'dashboard.favorites': { de: 'Favoriten', en: 'Favorites' },
  'dashboard.noFavorites': { de: 'Keine Favoriten. Klicke auf das Stern-Icon bei einem Gerät.', en: 'No favorites. Click the star icon on a device.' },

  // Devices
  'devices.title': { de: 'Geräte', en: 'Devices' },
  'devices.registered': { de: 'registriert', en: 'registered' },
  'devices.loadError': { de: 'Geräte konnten nicht geladen werden', en: 'Could not load devices' },
  'devices.noDevices': { de: 'Keine Geräte gefunden', en: 'No devices found' },
  'devices.computerName': { de: 'Computername', en: 'Computer name' },
  'devices.statusConnect': { de: 'Status / Verbinden', en: 'Status / Connect' },
  'devices.allTenants': { de: 'Alle Mandanten', en: 'All tenants' },
  'devices.allStatuses': { de: 'Alle Status', en: 'All statuses' },
  'devices.location': { de: 'Standort', en: 'Location' },
  'devices.lastSeen': { de: 'Zuletzt gesehen', en: 'Last seen' },
  'devices.justNow': { de: 'Gerade eben', en: 'Just now' },
  'devices.selected': { de: 'ausgewählt', en: 'selected' },
  'devices.executeScript': { de: 'Skript ausführen', en: 'Execute script' },
  'devices.customScript': { de: 'Eigenes Skript schreiben', en: 'Write custom script' },
  'devices.page': { de: 'Seite', en: 'Page' },
  'devices.of': { de: 'von', en: 'of' },
  'devices.tenant': { de: 'Mandant', en: 'Tenant' },
  'devices.export': { de: 'CSV Export', en: 'CSV Export' },
  'devices.import': { de: 'CSV Import', en: 'CSV Import' },
  'devices.compare': { de: 'Vergleichen', en: 'Compare' },
  'devices.tags': { de: 'Tags', en: 'Tags' },

  // Device Detail
  'detail.notFound': { de: 'Gerät nicht gefunden', en: 'Device not found' },
  'detail.remoteConnection': { de: 'Fernverbindung', en: 'Remote Connection' },
  'detail.primary': { de: 'Primär', en: 'Primary' },
  'detail.fallback': { de: 'Fallback', en: 'Fallback' },
  'detail.alternative': { de: 'Alternativ', en: 'Alternative' },
  'detail.connectVia': { de: 'Verbinden via', en: 'Connect via' },
  'detail.notConfigured': { de: 'Nicht konfiguriert', en: 'Not configured' },
  'detail.executeScripts': { de: 'Skripte ausführen', en: 'Execute scripts' },
  'detail.customScript': { de: 'Eigenes Skript', en: 'Custom script' },
  'detail.recentResults': { de: 'Letzte Skript-Ergebnisse', en: 'Recent script results' },
  'detail.deviceInfo': { de: 'Geräteinformationen', en: 'Device information' },
  'detail.deviceId': { de: 'Geräte-ID', en: 'Device ID' },
  'detail.ipAddress': { de: 'IP-Adresse', en: 'IP Address' },
  'detail.os': { de: 'Betriebssystem', en: 'Operating system' },
  'detail.locationTitle': { de: 'Standort', en: 'Location' },
  'detail.city': { de: 'Stadt', en: 'City' },
  'detail.address': { de: 'Adresse', en: 'Address' },
  'detail.stationCode': { de: 'Stations-Code', en: 'Station Code' },
  'detail.statusTitle': { de: 'Status', en: 'Status' },
  'detail.lastSeen': { de: 'Zuletzt gesehen', en: 'Last seen' },
  'detail.never': { de: 'Nie', en: 'Never' },
  'detail.editDevice': { de: 'Gerät bearbeiten', en: 'Edit device' },
  'detail.deleteDevice': { de: 'Gerät löschen', en: 'Delete device' },
  'detail.deleteConfirm': { de: 'löschen möchtest?', en: 'want to delete?' },
  'detail.updated': { de: 'Gerät aktualisiert', en: 'Device updated' },
  'detail.deleted': { de: 'Gerät gelöscht', en: 'Device deleted' },
  'detail.updateError': { de: 'Fehler beim Aktualisieren', en: 'Error updating' },
  'detail.deleteError': { de: 'Fehler beim Löschen', en: 'Error deleting' },
  'detail.noResult': { de: 'Noch kein Ergebnis', en: 'No result yet' },
  'detail.waitingResult': { de: 'Warte auf Ergebnis...', en: 'Waiting for result...' },
  'detail.saveTemplate': { de: 'Als Vorlage speichern', en: 'Save as template' },
  'detail.templateSaved': { de: 'Vorlage gespeichert', en: 'Template saved' },

  // Connection
  'connect.notAvailable': { de: 'ID nicht verfügbar', en: 'ID not available' },
  'connect.idCopied': { de: 'ID kopiert!', en: 'ID copied!' },
  'connect.connectingTo': { de: 'Verbinde mit', en: 'Connecting to' },

  // Scripts
  'scripts.sysinfo': { de: 'Systeminformationen', en: 'System Information' },
  'scripts.diskspace': { de: 'Festplattenplatz', en: 'Disk Space' },
  'scripts.winupdate': { de: 'Windows Update', en: 'Windows Update' },
  'scripts.diskcleaner': { de: 'Disk Cleanup', en: 'Disk Cleanup' },
  'scripts.services': { de: 'Dienste-Status', en: 'Service Status' },
  'scripts.network': { de: 'Netzwerk-Info', en: 'Network Info' },
  'scripts.restart': { de: 'PC Neustarten', en: 'Restart PC' },
  'scripts.security': { de: 'Sicherheits-Check', en: 'Security Check' },
  'scripts.eventlog': { de: 'Fehler-Log', en: 'Error Log' },
  'scripts.executeError': { de: 'Fehler beim Ausführen', en: 'Execution error' },
  'scripts.scriptName': { de: 'Mein Skript', en: 'My script' },
  'scripts.nameAndScriptRequired': { de: 'Name und Skript erforderlich', en: 'Name and script required' },
  'scripts.scriptRunning': { de: 'Skript wird ausgeführt', en: 'Script is running' },

  // Tenants
  'tenants.title': { de: 'Mandanten', en: 'Tenants' },
  'tenants.addTenant': { de: 'Mandant hinzufügen', en: 'Add tenant' },
  'tenants.newTenant': { de: 'Neuer Mandant', en: 'New tenant' },
  'tenants.loadError': { de: 'Mandanten konnten nicht geladen werden', en: 'Could not load tenants' },
  'tenants.noTenants': { de: 'Keine Mandanten vorhanden', en: 'No tenants available' },
  'tenants.fillAll': { de: 'Bitte alle Felder ausfüllen', en: 'Please fill all fields' },
  'tenants.created': { de: 'Mandant erstellt', en: 'Tenant created' },
  'tenants.deleted': { de: 'Mandant gelöscht', en: 'Tenant deleted' },
  'tenants.createError': { de: 'Fehler beim Erstellen', en: 'Error creating' },
  'tenants.deleteError': { de: 'Fehler beim Löschen', en: 'Error deleting' },
  'tenants.deleteConfirm': { de: 'wirklich löschen?', en: 'really delete?' },
  'tenants.uniqueId': { de: 'Eindeutiger Identifier', en: 'Unique identifier' },

  // Tenant Detail
  'td.notFound': { de: 'Mandant nicht gefunden', en: 'Tenant not found' },
  'td.devices': { de: 'Geräte', en: 'Devices' },
  'td.users': { de: 'Benutzer', en: 'Users' },
  'td.groups': { de: 'Gruppen', en: 'Groups' },
  'td.online': { de: 'online', en: 'online' },
  'td.searchPlaceholder': { de: 'Suche nach Name, Standort, Adresse, IP, Notizen...', en: 'Search by name, location, address, IP, notes...' },
  'td.continent': { de: 'Kontinent', en: 'Continent' },
  'td.country': { de: 'Land', en: 'Country' },
  'td.state': { de: 'Bundesland', en: 'State' },
  'td.city': { de: 'Stadt', en: 'City' },
  'td.poiType': { de: 'POI-Typ', en: 'POI Type' },
  'td.noDevicesFilter': { de: 'Keine Geräte für diesen Filter', en: 'No devices for this filter' },
  'td.noDevicesRegistered': { de: 'Keine Geräte registriert', en: 'No devices registered' },
  'td.noLocation': { de: 'Kein Standort hinterlegt', en: 'No location set' },
  'td.editLocation': { de: 'Standort & Details bearbeiten', en: 'Edit location & details' },
  'td.deviceUpdated': { de: 'Gerät aktualisiert', en: 'Device updated' },
  'td.addUser': { de: 'Benutzer erstellen', en: 'Create user' },
  'td.addUserTo': { de: 'Benutzer hinzufügen zu', en: 'Add user to' },
  'td.userCreated': { de: 'Benutzer erstellt', en: 'User created' },
  'td.userDeleted': { de: 'Gelöscht', en: 'Deleted' },
  'td.fillAll': { de: 'Alle Felder ausfüllen', en: 'Fill all fields' },
  'td.ofDevices': { de: 'von', en: 'of' },
  'td.devicesLabel': { de: 'Geräten', en: 'devices' },

  // Location / Continents / POI / Roles
  'loc.continent': { de: 'Kontinent', en: 'Continent' }, 'loc.country': { de: 'Land', en: 'Country' },
  'loc.state': { de: 'Bundesland', en: 'State' }, 'loc.city': { de: 'Stadt', en: 'City' },
  'loc.address': { de: 'Adresse', en: 'Address' }, 'loc.stationCode': { de: 'Stations-Code', en: 'Station Code' },
  'loc.notes': { de: 'Notizen / Wichtige Infos', en: 'Notes / Important Info' }, 'loc.poiType': { de: 'POI-Typ', en: 'POI Type' },
  'cont.europe': { de: 'Europa', en: 'Europe' }, 'cont.northAmerica': { de: 'Nordamerika', en: 'North America' },
  'cont.southAmerica': { de: 'Südamerika', en: 'South America' }, 'cont.asia': { de: 'Asien', en: 'Asia' },
  'cont.africa': { de: 'Afrika', en: 'Africa' }, 'cont.oceania': { de: 'Ozeanien', en: 'Oceania' },
  'poi.airport': { de: 'Flughafen', en: 'Airport' }, 'poi.trainStation': { de: 'Bahnhof', en: 'Train Station' },
  'poi.247': { de: '24/7 Standort', en: '24/7 Location' }, 'poi.important': { de: 'Wichtig', en: 'Important' },
  'poi.none': { de: 'Keiner', en: 'None' },
  'role.superadmin': { de: 'Superadmin', en: 'Superadmin' }, 'role.admin': { de: 'Admin', en: 'Admin' },
  'role.technician': { de: 'Techniker', en: 'Technician' }, 'role.viewer': { de: 'Betrachter', en: 'Viewer' },

  // Global Search & Header
  'search.placeholder': { de: 'Geräte, Mandanten, Gruppen suchen...', en: 'Search devices, tenants, groups...' },
  'search.noResults': { de: 'Keine Ergebnisse', en: 'No results' },
  'header.live': { de: 'LIVE', en: 'LIVE' },
  'header.offline': { de: 'OFFLINE', en: 'OFFLINE' },

  // New features
  'export.title': { de: 'CSV Export', en: 'CSV Export' },
  'export.success': { de: 'Export gestartet', en: 'Export started' },
  'import.title': { de: 'CSV Import', en: 'CSV Import' },
  'import.desc': { de: 'Standortdaten per CSV-Datei aktualisieren', en: 'Update location data via CSV file' },
  'import.success': { de: 'Import erfolgreich', en: 'Import successful' },
  'import.updated': { de: 'aktualisiert', en: 'updated' },
  'import.errors': { de: 'Fehler', en: 'errors' },
  'compare.title': { de: 'Geräte vergleichen', en: 'Compare devices' },
  'compare.select': { de: 'Geräte zum Vergleichen auswählen', en: 'Select devices to compare' },
  'tags.manage': { de: 'Tags verwalten', en: 'Manage tags' },
  'tags.add': { de: 'Tag hinzufügen', en: 'Add tag' },
  'tags.updated': { de: 'Tags aktualisiert', en: 'Tags updated' },
  'favorites.added': { de: 'Favorit hinzugefügt', en: 'Added to favorites' },
  'favorites.removed': { de: 'Favorit entfernt', en: 'Removed from favorites' },
  'templates.title': { de: 'Gespeicherte Vorlagen', en: 'Saved templates' },
  'templates.save': { de: 'Als Vorlage speichern', en: 'Save as template' },
  'templates.saved': { de: 'Vorlage gespeichert', en: 'Template saved' },
  'autoRefresh.label': { de: 'Auto-Refresh', en: 'Auto-Refresh' },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('tsr-language') || 'de');

  useEffect(() => { localStorage.setItem('tsr-language', language); }, [language]);

  const t = (key, params = {}) => {
    const entry = translations[key];
    if (!entry) return key;
    let text = entry[language] || entry.de || key;
    Object.entries(params).forEach(([k, v]) => { text = text.replace(`{${k}}`, v); });
    return text;
  };

  const toggleLanguage = () => setLanguage(prev => prev === 'de' ? 'en' : 'de');

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
